export const ADD_SINGLE_VISION_TYPES_SUCCESS = "ADD_SINGLE_VISION_TYPES_SUCCESS";
export const CREATE_SINGLE_VISION_TYPES_SUCCESS = "CREATE_SINGLE_VISION_TYPES_SUCCESS";
export const LIST_ALL_SINGLE_VISION_TYPE_REQUEST = "LIST_ALL_SINGLE_VISION_TYPE_REQUEST";
export const LIST_ALL_SINGLE_VISION_TYPE_SUCCESS = "LIST_ALL_SINGLE_VISION_TYPE_REQUEST_SUCCESS";
export const LIST_ALL_SINGLE_VISION_TYPE_FAILURE = "LIST_ALL_SINGLE_VISION_TYPE_FAILURE";
export const UPDATE_SINGLE_VISION_TYPES_SUCCESS = "UPDATE_SINGLE_VISION_TYPES_SUCCESS";
export const DELETE_SINGLE_VISION_TYPE_SUCCESS = "DELETE_SINGLE_VISION_TYPE_SUCCESS";
